'use client'

import { useLocale } from 'next-intl'
import { useEffect } from 'react'

import { userAtom } from '@/global-state'
import { getStore } from '@/store'
import { env } from '@/utils'

import {
	identifyUser,
	initPostHogOnce,
	posthogClient,
} from '../../lib/analytics/posthog'

/**
 * Mounts once at the app root. Handles SDK init, the bootstrap identify()
 * for an already-active session (MYQRCODE-10778 AC#6), and the `locale`
 * global property, the one entry on the registry's Global Properties sheet
 * that isn't init-only. $pageview capture itself is handled by posthog-js's
 * own 'history_change' mode (see lib/analytics/posthog.ts) — no manual
 * capture() call needed here.
 */
export const UsePostHog = () => {
	const locale = useLocale()

	useEffect(() => {
		initPostHogOnce().then(() => {
			const user = getStore().get(userAtom)
			if (user) {
				identifyUser({ id: user.id, email: user.email })
			}
		})
	}, [])

	useEffect(() => {
		if (!env.POSTHOG_KEY) return
		posthogClient.register({ locale })
	}, [locale])

	return null
}
